// ./src/utils/createInPlace.ts
//
// ROADMAP A2h #142 — may this person "Add new" from a picker, HERE? The server decides every create by the account the
// record will belong to and by who is writing (eventsmagic-api `crewEventGate.authorizeCreate` + `planFeatureGate`), so
// a picker that offers what the server would refuse leads a host into a drawer that ends in an error. Each picker
// states its RULE — what the server demands of a crew member for that create — and this answers:
//   • the account's own people (not working an event as crew) always may — the server checks their own account;
//   • a crew member may only where the server has a CREW path for that create, and only holding its capability;
//   • a create the server always puts in the CALLER's own account (venues, contacts, tags, categories…) is never
//     offered to a crew member: it would land in their own account, out of this event's reach.
// The PLAN half is `useFeatureGate` (the event account's plan in its workspace). Pure.

import { CREW_CAPABILITY } from "@/config/crewCapabilities";

/** The create lands in the caller's own account — the server has no crew path for it. */
export const CREATE_IN_OWN_ACCOUNT = "own-account" as const;

/** What a crew member needs to create this kind of record in the event's account. */
export type CreateInPlaceRule = { capability: string } | typeof CREATE_IN_OWN_ACCOUNT;

export interface CreateInPlaceAccess {
  /** The event workspace this access is for — null outside an event (the account's own pages). */
  eventId: string | null;
  /** The event access is still being read — say nothing yet rather than offer and then withdraw. */
  loading: boolean;
  /** One of the event account's own people (as the access read says). */
  isOwner: boolean;
  /** The event belongs to the signed-in person's own account (known from the event itself — no access read needed). */
  ownsEvent: boolean;
  /** Working this event as crew (not one of its account's own people). */
  isCrewMode: boolean;
  hasCapability: (capability: string) => boolean;
}

export const mayCreateInPlace = (rule: CreateInPlaceRule, access: CreateInPlaceAccess): boolean => {
  // Outside an event the record is the account's own, and the server checks that account; inside one of the person's
  // OWN events the same — known from the event itself, so a failed or slow access read never costs an owner.
  if (!access.eventId || access.isOwner || access.ownsEvent) {
    return true;
  }

  if (access.loading) {
    return false;
  }

  // ⚠ FAIL CLOSED inside an event whose access is not known (the read failed, or gave none): neither owner nor crew.
  if (!access.isCrewMode || rule === CREATE_IN_OWN_ACCOUNT) {
    return false;
  }

  return access.hasCapability(rule.capability);
};

/** Event catalogs a crew member creates with `event.operate` (channels, acts, stock items, rental assets). */
export const CREATE_FOR_EVENT_OPERATORS: CreateInPlaceRule = { capability: CREW_CAPABILITY.EVENT_OPERATE };

/** Guest groupings a crew member creates with `guests.edit` (guest groups, RSVP groups). */
export const CREATE_FOR_GUEST_EDITORS: CreateInPlaceRule = { capability: CREW_CAPABILITY.GUESTS_EDIT };

/** A policy (waiver / consent) created from an event — a crew member needs `event.settings` (PolicyCore). */
export const CREATE_FOR_EVENT_SETTINGS: CreateInPlaceRule = { capability: CREW_CAPABILITY.EVENT_SETTINGS };
